import { render } from "./MiddleCloseButton.vue?vue&type=template&id=684a7cb8&scoped=true"
import script from "./MiddleCloseButton.vue?vue&type=script&lang=js"
export * from "./MiddleCloseButton.vue?vue&type=script&lang=js"

import "./MiddleCloseButton.vue?vue&type=style&index=0&id=684a7cb8&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684a7cb8"]])

export default __exports__